module.exports = __webpack_public_path__ + "img/rimg5.4fd73b10.png";